import { render } from "./InwardsDashboard.vue?vue&type=template&id=2b671eb0"
import script from "./InwardsDashboard.vue?vue&type=script&lang=js"
export * from "./InwardsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__